import { AxiosError } from 'axios';
import { UserGroupApproverRequest } from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import { useCustomMutation } from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import { PUT_REQUEST_PROFILE_AMENDMENT_URL } from '../../constants/apiUrls';
import { GenericErrorResponse } from '../typings';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface RequestProfileAmendmentRequest {
  candidateProfileAmendmentModel: {
    name: string | null;
    userIdType: string | null;
    identity: string | null;
    dateOfBirth: string | null;
    prStatus: string | null;
    citizenship: string | null;
  };
  requestDetail: UserGroupApproverRequest;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutRequestProfileAmendment = ({ onSuccess, onError }: Input = {}) => {
  const putRequestProfileAmendment = async (reqBody: RequestProfileAmendmentRequest) => {
    await axiosClient.put<void>(PUT_REQUEST_PROFILE_AMENDMENT_URL, reqBody);
  };

  return useCustomMutation(putRequestProfileAmendment, {
    onSuccess,
    onError,
  });
};
